import React, { useState } from "react";
import { QRCodeSVG } from 'qrcode.react';
import { Container } from "@mui/system";
import Logo from "../../assets/img/logo-reenergisa.png";
import {
    Grid, Card, Box, CardHeader, CardContent, Button, Typography, Tooltip,
    Paper, Modal, TextField, Divider, IconButton
} from '@mui/material';
import CustomLoading from "../../components/CustomLoading";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import DoneIcon from '@mui/icons-material/Done';
import UndoIcon from '@mui/icons-material/Undo';
import storage from "../../services/storage";
import api from "../../services/api";
import './styles.css';

const LoginTerceirosCodePage = () => {
    const [showLoading, setShowLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [valueCodAuth, setValueCodAuth] = useState("");
    const [valueQrcode, setValueQrcode] = useState("");

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handlerClickCheckEmail(event);
            return true;
        }
    };

    function handlerClickCheckEmail(e) {
        e.preventDefault();
        setShowLoading(true);

        let email = storage.getTerceiroEmail();

        let requestBody = {
            email: email,
            senha: 'sem senha',
            pass: storage.getTerceiroPass(),
            cod_auth: valueCodAuth
        };

        api.initExternal.post('', requestBody).then((response) => {
            if (response.data.error !== undefined) {
                setErrorText(response.data.error);
            } else {
                storage.setAwsValidation(response.data.data.token, email, response.data.data.data.user.permisao);
                storage.setAzureAdValidation(response.data.data.data.user.nome, response.data.data.data.user.empresa);

                if(response.data.data.data.user.primeiro_acesso === 1){
                    window.location = '/alterar-senha-acesso';
                }else if(response.data.data.data.user.primeiro_acesso === 0){
                    window.location = 'pages/home'
                }
            }

            setShowLoading(false);
        })
            .catch(() => {
                setErrorText("Código de autenticação inválido!");
                setShowLoading(false);
            });
    }

    function handlerClickShowModalInstruction(e) {
        e.preventDefault();

        let uriQrcode = storage.getTerceiroUriQrCode();

        setValueQrcode(uriQrcode);
        setShowModal(true);
    }

    function handleCloseModal() {
        setShowModal(false);
    }

    return (
        <>
            <CustomLoading show={showLoading} />
            <Modal
                aria-labelledby="customized-dialog-title"
                open={showModal}
                onClose={handleCloseModal}
            >
                <Container className="container-modal">
                    <Paper className="paper-modal">
                        <Typography gutterBottom className="text-informacoes">
                            No seu primeiro acesso ao Energisa Dash você precisa instalar o Multifator de Autenticação (MFA)
                            para ser utilizado nos acessos seguintes.
                        </Typography>
                        <br />
                        <Typography gutterBottom className="text-informacoes">
                            Esse mecanismo provê maior segurança para seu acesso.
                        </Typography>
                        <br />
                        <Typography gutterBottom className="text-informacoes">
                            Siga os passos seguintes para configurar o Microsoft Authenticator:
                        </Typography>
                        <ol>
                            <li>
                                Abra o app Microsoft Authenticator.
                            </li>
                            <li>
                                Clicar no "+" na parte superior do app (necessario logar no app no primeiro acesso).
                            </li>
                            <li>
                                Selecionar conta pessoal.
                            </li>
                            <li>
                                Selecionar escanear QrCode.
                            </li>
                            <li>
                                Aponte para o QrCode abaixo.
                            </li>
                            <li>
                                QrCode para ser usado dentro do Autenticador (escanear com a camera dentro do app do autenticador).
                            </li>
                        </ol>

                        <div className="content-qrcode">
                            <QRCodeSVG
                                value={valueQrcode}
                            />
                        </div>
                        <br />
                        <Typography gutterBottom className="text-informacoes-adicionais">
                            Link para baixar o app Autenticador da Microsoft: <a href="https://www.microsoft.com/pt-br/security/mobile-authenticator-app">Microsoft Authenticator</a>.
                        </Typography>
                    </Paper>
                </Container>
            </Modal>

            <Container maxWidth="sm" className="text-center margin-top-50px">
                <Grid container direction="row" justifyContent="center" alignItems="center" mt={2} className="text-center padding-30px-15px">
                    <Grid item lg={8} md={8} sm={6} className="text-center">
                        <Card elevation={3} className="text-center padding-20px">
                            <Box>
                                <img src={Logo} className="width-100px" alt="logo" />
                            </Box>
                            <CardHeader title="EnergisaDash" subheader="Dashboards." />

                            <CardContent>
                                <Grid container className="margin-top-25px text-left">
                                    <Grid item lg={12} sm={12}>
                                        <Typography className="font-size-9-pt color-disabled">
                                            Código de 6 dígitos do Microsoft Authenticator para o EnergisaDash. <br />
                                            <br />
                                        </Typography>
                                    </Grid>

                                    <Paper
                                        component="form"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                                    >
                                        <LockOpenIcon color="primary" />
                                        <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
                                        <TextField
                                            name="input-cod-auth"
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Código do Autenticador"
                                            inputProps={{ 'aria-label': 'Código do Autenticador' }}
                                            value={valueCodAuth}
                                            onChange={(e) => setValueCodAuth(e.target.value)}
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            variant="standard"
                                            error={errorText !== ""}
                                            helperText={errorText}
                                        />
                                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                        <Tooltip title={"Confirmar"}>
                                            <IconButton color="primary" sx={{ p: '10px' }} aria-label="done" onClick={(e) => handlerClickCheckEmail(e)}>
                                                <DoneIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Paper>

                                    <Grid item lg={12} sm={12}>
                                        <Typography className="font-size-9-pt color-disabled">
                                            <br />
                                            <br />
                                            <br />
                                            Primeiro acesso? Clique <span className="clique-aqui" onClick={(e) => handlerClickShowModalInstruction(e)}>aqui</span>. <br />
                                            <br />
                                        </Typography>
                                    </Grid>

                                    <Grid item lg={12} sm={12} className="text-right">
                                        <Button variant="outlined" startIcon={<UndoIcon />} onClick={() => window.location = '/login-terceiros'}>
                                            Voltar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>

                        <Grid container mt={1}>
                            <Grid item lg={12} sm={6} className="text-right padding-10px">
                                <Button className="color-disabled">Ajuda</Button>
                                <Button className="color-disabled">Privacidade</Button>
                                <Button className="color-disabled">Termos</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>

        </>
    )
}

export default LoginTerceirosCodePage;